import { Avatar, type AvatarProps } from '@frontend/components';

export const CustomAvatar = (props: AvatarProps) => (
  <Avatar alignSelf="center" marginY="auto" size="xs" {...props} />
);
